import { useContext, useEffect, useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { Office365GroupContext } from "../../context/Office365GroupContext";

export const useOffice365GroupMembership = () => {
    const [state, setState] = useState({ isLoaded: false, error: null });
    const { authState } = useOktaAuth();
    const { groupModule, setGroupModule } = useContext(Office365GroupContext);

    useEffect(() => {
        const fetchMembers = async () => {
            if (groupModule.isOpen && groupModule.mode === "read") {
                try {
                    const res = await fetch(
                        `${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/groups/office365/membership/read`,
                        {
                            method: "POST",
                            headers: {
                                Authorization: authState.accessToken.accessToken,
                                "Content-Type": "application/json",
                                Accept: "application/json",
                            },
                            body: JSON.stringify({ groupId: groupModule.id }),
                        }
                    );
                    const result = await res.json();
                    setGroupModule((prev) => ({ ...prev, members: result.members }));
                    setState((prev) => ({ ...prev, isLoaded: true }));
                } catch (error) {
                    setState((prev) => ({ ...prev, isLoaded: true, error }));
                }
            }
        };
        fetchMembers();
    }, [authState, groupModule?.id]);

    return state;
};
